import React from "react";
import { isSlotVisible, slotCss } from "../utils/signupTextStyle";

export default function StepChoice({ venue, onChoice }) {
  // Master switches from GET /:slug/info. Default ON (treat a missing flag as
  // enabled) so this stays backwards-compatible with older venue records.
  const signupOn  = venue?.signup_enabled  !== false;
  const renewalOn = venue?.renewal_enabled !== false;

  // This step has its OWN heading + subtitle (Branding → "First step" copy),
  // separate from the card header's welcome_title/subtitle — otherwise the same
  // sentence appears twice on one screen. Both fall back to built-in wording
  // when the venue hasn't set them, so nothing is blank out of the box.
  const title = venue?.choice_title || "Welcome!";
  const subtitle = venue?.choice_subtitle || null;
  // Each line can be switched off per venue (Branding → signup text).
  const showTitle = isSlotVisible(venue, "choice_title");
  const showSub   = isSlotVisible(venue, "choice_subtitle");

  // Both paths closed — nothing to offer.
  if (!signupOn && !renewalOn) {
    return (
      <>
        {showTitle && <h2 className="step-title" style={slotCss(venue, "choice_title")}>{title}</h2>}
        <p className="step-sub" style={slotCss(venue, "choice_subtitle")}>
          Membership signups are currently closed. Please check back later or contact the venue.
        </p>
      </>
    );
  }

  return (
    <>
      {showTitle && <h2 className="step-title" style={slotCss(venue, "choice_title")}>{title}</h2>}
      {showSub && (
      <p className="step-sub" style={slotCss(venue, "choice_subtitle")}>
        {subtitle || (signupOn && renewalOn
          ? "Are you an existing member or joining for the first time?"
          : renewalOn
            ? "Renew your existing membership below."
            : "Join for the first time below.")}
      </p>
      )}

      <div className={`choice-grid${(renewalOn ? 1 : 0) + (signupOn ? 1 : 0) === 1 ? " choice-grid--single" : ""}`}>
        {renewalOn && (
          <button className="choice-btn" type="button" onClick={() => onChoice(true)}>
            <span className="choice-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="4" width="20" height="16" rx="2.5" /><circle cx="8.5" cy="10" r="2" /><path d="M5 16a3.5 3.5 0 0 1 7 0" /><line x1="15" y1="9" x2="19" y2="9" /><line x1="15" y1="13" x2="19" y2="13" />
              </svg>
            </span>
            <span className="choice-label">Existing Member</span>
            <span className="choice-hint">I have a membership or card number</span>
          </button>
        )}

        {signupOn && (
          <button className="choice-btn" type="button" onClick={() => onChoice(false)}>
            <span className="choice-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><line x1="19" y1="8" x2="19" y2="14" /><line x1="22" y1="11" x2="16" y2="11" />
              </svg>
            </span>
            <span className="choice-label">New Member</span>
            <span className="choice-hint">I'm joining for the first time</span>
          </button>
        )}
      </div>
    </>
  );
}
